import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ComponentVersionRoute({ children }) {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.is_super_admin;
  const canAccess = isAdmin || user?.permissions?.component_versions;

  if (!canAccess) {
    return <Navigate to="/" replace />;
  }

  return children;
}
